export const INITIAL_STATE = {
  error: false,
  loading: true,
  collegeMetrics: {
    reached_students_total: {},
    student_impressions_total: {},
    registered_with_parent: {},
    attending_title_1_hs: {},
    first_gen_student: {},
    reached_academic_focus: {
      audience_academic_focus: [],
      not_reached_academic_focus: [],
      reached_academic_focus: [],
    },
    reached_interest: {
      audience_interests: [],
      not_reached_interests: [],
      reached_interests: [],
    },
    reached_by_grad_year: [],
    engaged_registered_with_parent: {},
    engaged_first_gen_student: {},
    engaged_attending_title_1_hs: {},
    engaged_students_totals: {},
    competitors: [],
    competitors_adjusted: [],
    engaged_academic_focus: {},
    engaged_interest: {},
    student_conversions: [],
  },
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        error: false,
        loading: true,
      }
    case 'loaded': {
      const { data } = action
      return {
        ...state,
        collegeMetrics: data,
        error: false,
        loading: false,
      }
    }
    case 'error': {
      return {
        ...state,
        error: true,
        loading: false,
      }
    }
    default:
      return state
  }
}
